export const sideCarousel = {
  slides: {
    qualityProgram: {
      title: "A higher standard <1>for your health.</1>",
      description:
        "Access trusted supplements, labs, and wellness products backed by our quality program.",
      verifiedBrandsTitle: "Verified brands",
      verifiedBrandsDescription: "Sourced straight from the brand — no resellers, no fakes.",
      enhancedTestingTitle: "Enhanced testing",
      enhancedTestingDescription:
        "Select products are tested in-house — so you get exactly what the label promises.",
      storedAndShippedTitle: "Stored and shipped",
      storedAndShippedDescription: "From our certified facilities, to preserve product integrity.",
    },
    mobileApp: {
      title: "[Placeholder] Patients love Fullscript even more on the app",
      body: "[Placeholder] Scan to download the free Fullscript app.",
    },
  },
} as const;
